export default "__VITE_ASSET__DfFWw7jY__"